import { renderTopbar } from '../components/topbar.js';
import { renderQuizTakersTable } from '../components/quizTakersTable.js';
import { getMyTeachingCourses, getBoundCourseQuizResults } from '../lib/school.js';
import { friendlyError } from '../lib/friendlyError.js';

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// "Teaching" (#/teaching) — a teacher's own view of the courses their
// school has bound them to (see functions/schools.js bindTeacherToCourse),
// each showing the same "who took this quiz and how did they score"
// visibility the course owner gets in views/course.js's Quiz results panel.
export function renderTeaching(container) {
  container.innerHTML = '';
  container.appendChild(renderTopbar('/teaching'));

  const main = document.createElement('div');
  main.className = 'main-full';
  main.innerHTML = `<div class="empty-state">Loading your courses…</div>`;
  container.appendChild(main);

  getMyTeachingCourses()
    .then((courses) => {
      main.innerHTML = `
        <h1 style="margin-bottom:4px;">🍎 Teaching</h1>
        <p style="color:var(--text-dim);margin-top:0;">Courses your school has bound you to, and their quiz results.</p>
        ${courses.length === 0
          ? '<div class="empty-state"><div style="font-size:2.5rem;">📚</div><h3>No courses yet</h3><p>Your school hasn\'t bound you to any course yet.</p></div>'
          : `
            <div style="display:flex;gap:8px;flex-wrap:wrap;margin:12px 0;" id="teaching-course-tabs">
              ${courses.map((c, i) => `<button class="btn btn-sm" data-course-idx="${i}">${escapeHtml(c.courseTitle || 'Untitled course')}</button>`).join('')}
            </div>
            <div class="settings-panel" id="teaching-results-panel">
              <h3>Quiz results</h3>
              <div id="teaching-results-body"><p style="color:var(--text-dim);font-size:0.86rem;">Select a course above.</p></div>
            </div>
          `}
      `;
      if (courses.length === 0) return;

      const body = main.querySelector('#teaching-results-body');
      function showCourse(idx) {
        const course = courses[idx];
        if (!course) return;
        body.innerHTML = '<p style="color:var(--text-dim);font-size:0.86rem;">Loading…</p>';
        getBoundCourseQuizResults(course.courseId)
          .then((results) => {
            renderQuizTakersTable(body, results, { showTopic: true, emptyMessage: 'No one has taken a quiz in this course yet.' });
          })
          .catch((err) => {
            body.innerHTML = `<p style="color:var(--danger);font-size:0.86rem;">${escapeHtml(friendlyError(err, 'Could not load quiz results.'))}</p>`;
          });
      }
      main.querySelectorAll('[data-course-idx]').forEach((btn) => {
        btn.addEventListener('click', () => showCourse(Number(btn.dataset.courseIdx)));
      });
      showCourse(0);
    })
    .catch((err) => {
      main.innerHTML = `<div class="empty-state"><p>${friendlyError(err, 'Could not load your courses.')}</p></div>`;
    });

  return () => {};
}
